import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getLocationList = async ({ companyCode }) => {
  if (!companyCode) return [];
  const { data } = await http_payroll.get(
    `${Api_EndPoints.LocationAPI}?isAll=true&CompanyCode=${companyCode}`
  );
  return data;
};

const getLocationById = async ({ companyCode, code }) => {
  if (code) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.LocationAPI}?isAll=false&LocationCode=${code}&CompanyCode=${companyCode}`
    );
    return data;
  }
  return [];
};

const insertLocation = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.LocationAPI, input);
  return data;
};

const updateLocation = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.LocationAPI, input);
  return data;
};

const deleteLocation = async ({ locationCode, companyCode }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.LocationAPI}?LocationCode=${locationCode}&CompanyCode=${companyCode}`
  );
  return data;
};

export const useGetLocationQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.LocationAPI, companyCode],
    queryFn: () => getLocationList(companyCode),

  });
};

export const useGetLocationByIdQuery = (input) => {
  return useQuery({
    queryKey: [`${Api_EndPoints.LocationAPI}BYID`],
    queryFn: () => getLocationById(input),
    refetchOnWindowFocus: false,
    // staleTime: Infinity,
  });
};

export const useInsertLocationMutation = () => {
  return useMutation({
    mutationFn: insertLocation,
  });
};

export const useUpdateLocationMutation = () => {
  return useMutation({
    mutationFn: updateLocation,
  });
};

export const useDeleteLocationMutation = () => {
  return useMutation({
    mutationFn: deleteLocation,
  });
};
